import API from "@/api/permission";
import router, {DynamicRoutes} from "@/router/index";
import {recursionRouter, setDefaultRoute, filterAsyncRouter} from "@/utils/recursion-router";
import dynamicRouter from "@/router/dynamic-router";
import ROLE from "@/api/api_role";
// const store = resolve => require(['@/store/index'], resolve)
const Home = resolve => require(["@/pages/home/Home"], resolve);
const Dashboard = resolve => require(["@/pages/dashboard/Dashboard"], resolve);
const Admin = resolve => require(["@/pages/admin/Admin"], resolve);
const Role = resolve => require(["@/pages/role/Role"], resolve);
const Task = resolve => require(["@/pages/task/Task"], resolve);
const Complaint = resolve => require(["@/pages/complaint/Complaint"], resolve);
const TaskDetail = resolve => require(["@/pages/taskDetail/TaskDetail"], resolve);
const Banner = resolve => require(["@/pages/banner/Banner"], resolve);
const Challenge = resolve => require(["@/pages/challenge/Challenge"], resolve);
const PayOrder = resolve => require(["@/pages/payOrder/PayOrder"], resolve);
const TaskType = resolve => require(["@/pages/taskType/TaskType"], resolve);
const Authority = resolve => require(["@/pages/authority/Authority"], resolve);
const Users = resolve => require(["@/pages/users/Users"], resolve);
const Members = resolve => require(["@/pages/members/Members"], resolve);
const Blacklist = resolve => require(["@/pages/blacklist/Blacklist"], resolve);
const Membership = resolve => require(["@/pages/membership/Membership"], resolve);
const MemOrder = resolve => require(["@/pages/memOrder/MemOrder"], resolve);
const SuperInvite = resolve => require(["@/pages/superInvite/SuperInvite"], resolve);
const Wechat = resolve => require(["@/pages/wechat/Wechat"], resolve);
const TaskTop = resolve => require(["@/pages/taskTop/TaskTop"], resolve);
const TaskUserTop = resolve => require(["@/pages/taskUserTop/TaskUserTop"], resolve);
const TaskRecommand = resolve => require(["@/pages/taskRecommand/TaskRecommand"], resolve);
const TaskUserRefresh = resolve => require(["@/pages/taskUserRefresh/TaskUserRefresh"], resolve);
const Versions = resolve => require(["@/pages/versions/Versions"], resolve);
const Feedback = resolve => require(["@/pages/feedback/Feedback"], resolve);
const Refresh = resolve => require(["@/pages/refresh/Refresh"], resolve);
const RefreshOrder = resolve => require(["@/pages/refreshOrder/RefreshOrder"], resolve);
const PayInfo = resolve => require(["@/pages/payInfo/PayInfo"], resolve);
const Withdraw = resolve => require(["@/pages/withdraw/Withdraw"], resolve);
const WithdrawApply = resolve => require(["@/pages/withdrawApply/WithdrawApply"], resolve);
const Guarantee = resolve => require(["@/pages/guarantee/Guarantee"], resolve);
const WithdrawConfig = resolve => require(["@/pages/withdrawConfig/WithdrawConfig"], resolve);
const Fund = resolve => require(["@/pages/fund/Fund"], resolve);
const Notice = resolve => require(["@/pages/notice/Notice"], resolve);
const Reward = resolve => require(["@/pages/reward/Reward"], resolve);
const RewardLog = resolve => require(["@/pages/rewardLog/RewardLog"], resolve);
const FundDetail = resolve => require(["@/pages/fundDetail/FundDetail"], resolve);
const Channel = resolve => require(["@/pages/channel/Channel"], resolve);
// const Navy = resolve => require(["@/pages/Navy/Navy"], resolve);
const PromotionNavy = resolve => require(["@/pages/promotionNavy/PromotionNavy"], resolve);
const PromotionChannel = resolve => require(["@/pages/promotionChannel/PromotionChannel"], resolve);
const UnBind = resolve => require(["@/pages/unbind/UnBind"], resolve);
const Announcement = resolve => require(["@/pages/announcement/Announcement"], resolve);
const ExceptionUser = resolve => require(["@/pages/exceptionUser/ExceptionUser"], resolve);
const Game = resolve => require(["@/pages/game/Game"], resolve);
const ExtOverview = resolve => require(["@/pages/extOverview/ExtOverview"], resolve);
const ExtTaskData = resolve => require(["@/pages/extTaskData/ExtTaskData"], resolve);
const ExtProfitData = resolve => require(["@/pages/extProfitData/ExtProfitData"], resolve);
const ExtAgentData = resolve => require(["@/pages/extAgentData/ExtAgentData"], resolve);
const RankBoot = resolve => require(["@/pages/rankBoot/RankBoot"], resolve);
const Report = resolve => require(["@/pages/report/Report"], resolve);
const GameChannel = resolve => require(["@/pages/gameChannel/GameChannel"], resolve);
const ExtWithdraw = resolve => require(["@/pages/extWithdraw/ExtWithdraw"], resolve);
const ExtWithdrawDetail = resolve => require(["@/pages/extWithdrawDetail/ExtWithdrawDetail"], resolve);
const ExtWithdrawApply = resolve => require(["@/pages/extWithdrawApply/ExtWithdrawApply"], resolve);
const ExtCallbackData = resolve => require(["@/pages/extCallbackData/ExtCallbackData"], resolve);
const ExtBaseData = resolve => require(["@/pages/extBaseData/ExtBaseData"], resolve);
const ExtPromotionData = resolve => require(["@/pages/extPromotionData/ExtPromotionData"], resolve);
const PromotionUser = resolve => require(["@/pages/promotionUser/PromotionUser"], resolve);
const PayBackUser = resolve => require(["@/pages/payBackUser/PayBackUser"], resolve);
const ExtChannel = resolve => require(["@/pages/extChannel/ExtChannel"], resolve);
const PayBackInviter = resolve => require(["@/pages/payBackInviter/PayBackInviter"], resolve);
const PayBackMerchant = resolve => require(["@/pages/payBackMerchant/PayBackMerchant"], resolve);
const UserProfitRatio = resolve => require(["@/pages/userProfitRatio/UserProfitRatio"], resolve);

const PromotionUserInviteNum = resolve => require(["@/pages/PromotionUserInviteNum/PromotionUserInviteNum"], resolve);
const BlockedInfo = resolve => require(["@/pages/blockedInfo/BlockedInfo"], resolve);
const FundModifyRecord = resolve => require(["@/pages/fundModifyRecord/FundModifyRecord"], resolve);



export default {
  namespaced: true,
  state: {
    permissionList: "" /** 所有路由 */,
    sidebarMenu: [] /** 导航菜单 */,
    currentMenu: "" /** 当前active导航菜单 */
  },
  getters: {},
  mutations: {
    SET_PERMISSION(state, routes) {
      state.permissionList = routes;
    },
    CLEAR_PERMISSION(state) {
      state.permissionList = null;
    },
    SET_MENU(state, menu) {
      state.sidebarMenu = menu;
    },
    CLEAR_MENU(state) {
      state.sidebarMenu = [];
    },
    SET_CURRENT_MENU(state, currentMenu) {
      state.currentMenu = currentMenu;
    }
  },
  actions: {
    FETCH_PERMISSION({commit}) {
      let menus = router.options.routes;
      let authList = [];
      // 权限列表
      ROLE.findById().then((res) => {
        if (res.code === 0) {
          for (var i = 0; i < res.data.length; i++) {
            let obj = res.data[i];
            // 由JSON字符串转换为JSON对象
            // eslint-disable-next-line no-eval
            let objJson = eval("(" + obj + ")");

            menus.push(objJson);
            authList.push(objJson);
          }
          router.addRoutes(authList);
        } else {
          console.log("获取失败");
        }
      });

      commit("SET_MENU", menus);

      /*  初始路由 */
      let initialRoutes = router.options.routes;

      /*  动态添加路由 */
      // router.addRoutes(DynamicRoutes)
      /* 完整的路由表 */
      commit("SET_PERMISSION", [...initialRoutes, ...authList]);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js